import { CrudViewColumnType } from '../list-grid/crud-view-column-type.enum';

/**
 * Creates a display format function for date fields
 * Used in field configurations to format date values for display
 * @param columnType - The column type (Date or DateTime)
 * @returns A function that formats date values
 */
export function createDateDisplayFormatFunction(
  columnType: CrudViewColumnType.Date | CrudViewColumnType.DateTime
): (value: any) => string {
  return (value: any) => {
    if (!value) {
      return '';
    }

    try {
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return String(value);
      }

      const isDateOnly = columnType === CrudViewColumnType.Date;
      const locale = 'en-US';

      if (isDateOnly) {
        return date.toLocaleDateString(locale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      } else {
        return date.toLocaleDateString(locale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    } catch (error) {
      return String(value);
    }
  };
}

/**
 * Formats a date value for display based on column type
 * @param value - The date value to format
 * @param columnType - The column type (Date or DateTime)
 * @returns Formatted date string
 */
export function formatDateForDisplay(
  value: any,
  columnType: CrudViewColumnType.Date | CrudViewColumnType.DateTime
): string {
  const formatFn = createDateDisplayFormatFunction(columnType);
  return formatFn(value);
}

